import { render } from "./SoilAnalysisLegend.vue?vue&type=template&id=131a7b6f&scoped=true"
import script from "./SoilAnalysisLegend.vue?vue&type=script&lang=js"
export * from "./SoilAnalysisLegend.vue?vue&type=script&lang=js"

import "./SoilAnalysisLegend.vue?vue&type=style&index=0&id=131a7b6f&scoped=true&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131a7b6f"],['__file',"resources/js/Partials/Map/components/SoilAnalysisLegend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "131a7b6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('131a7b6f', __exports__)) {
    console.log('reload')
    api.reload('131a7b6f', __exports__)
  }
  
  module.hot.accept("./SoilAnalysisLegend.vue?vue&type=template&id=131a7b6f&scoped=true", () => {
    console.log('re-render')
    api.rerender('131a7b6f', render)
  })

}


export default __exports__